import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';




export function getCrucigramaListSuccess(crucigrama) {
  return {type: types.LOAD_CRUCIGRAMA_LIST_SUCCESS, crucigrama};
}



export function getCrucigramaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CrucigramaApi.getCrucigramaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(crucigrama => {                  
                  dispatch(getCrucigramaListSuccess(crucigrama));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCrucigramaSuccess(catalogo) {
  return {type: types.LOAD_CRUCIGRAMA_SUCCESS, catalogo};
}

export function getCrucigrama(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().CrucigramaApi.getCrucigrama(id, token).then(crucigrama => {   
        dispatch(getCrucigramaSuccess(crucigrama));
        return crucigrama;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(crucigrama) {
  return {type: types.SAVE_CRUCIGRAMA_SUCCESS, crucigrama};
}


export function save(crucigrama, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CrucigramaApi.save(crucigrama, token).then(crucigramaGuardado => {   
    dispatch(saveSuccess(crucigramaGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getCrucigramaComboSuccess(datos) {
  return {type: types.GET_CRUCIGRAMAS_COMBO_SUCCESS, datos};
}

export function getCrucigramaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().CrucigramaApi.getCrucigramaCombo(token).then(datos => {   
        
      dispatch(getCrucigramaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(crucigrama) {
  return {type: types.BORRAR_CRUCIGRAMA_SUCCESS, crucigrama};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CrucigramaApi.borrar(id, token ).then(crucigrama => {
               
                  dispatch(borrarSuccess(crucigrama));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(crucigrama) {
  return {type: types.ACTIVAR_CRUCIGRAMA_SUCCESS, crucigrama};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CrucigramaApi.activar(id, token).then(crucigrama => {
               
                  dispatch(activarSuccess(crucigrama));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CRUCIGRAMA, filtro};
}



